export const EDITOR_QUERY_PARAM = 'editor';
// Its own parameter: `?editor=` switches the form editor and must not switch every compact field.
export const PAGELESS_EDITOR_QUERY_PARAM = 'pagelessEditor';
export const PRISM_VALUE = 'prism';
export const CKEDITOR_VALUE = 'ckeditor';
export const EDITOR_VALUES = [PRISM_VALUE, CKEDITOR_VALUE];
